import type { BrainCollectedState } from '../../../../services/brainService';

type Props = {
  state: BrainCollectedState;
};

export default function AIArchitectureCanvas({ state }: Props) {
  return (
    <div className="flex h-full min-h-0 flex-col rounded-xl border border-slate-200 bg-gradient-to-b from-white to-slate-50 shadow-sm">
      <div className="border-b border-slate-100 px-4 py-3">
        <h2 className="text-sm font-semibold text-slate-900">Live plan</h2>
        <p className="text-xs text-slate-500">Updates as tools run on the server</p>
      </div>
      <div className="min-h-0 flex-1 space-y-4 overflow-y-auto p-4 text-sm text-slate-700">
        <div>
          <div className="text-xs font-medium uppercase tracking-wide text-slate-400">Project</div>
          {state.projectName || state.projectId ? (
            <ul className="mt-1 list-inside list-disc text-slate-800">
              {state.projectName && <li>Name: {state.projectName}</li>}
              {state.projectId && <li className="font-mono text-xs">ID: {state.projectId}</li>}
            </ul>
          ) : (
            <p className="text-slate-500">Not created yet</p>
          )}
        </div>
        {state.capacity && (
          <div>
            <div className="text-xs font-medium uppercase tracking-wide text-slate-400">Capacity</div>
            <p className="mt-1">
              {state.capacity.value} {state.capacity.unit}
            </p>
          </div>
        )}
        {state.solarPlan && (
          <div>
            <div className="text-xs font-medium uppercase tracking-wide text-slate-400">Solar counts</div>
            <pre className="mt-1 overflow-x-auto rounded-lg bg-slate-900/90 p-3 text-xs text-slate-100">
              {JSON.stringify(state.solarPlan, null, 2)}
            </pre>
          </div>
        )}
        {state.lastPreviewSummary && (
          <div>
            <div className="text-xs font-medium uppercase tracking-wide text-slate-400">Last preview</div>
            <pre className="mt-1 whitespace-pre-wrap rounded-lg border border-amber-100 bg-amber-50/80 p-3 text-xs text-amber-950">
              {state.lastPreviewSummary}
            </pre>
          </div>
        )}
        {state.lastCommitSummary && (
          <div>
            <div className="text-xs font-medium uppercase tracking-wide text-green-600">Committed</div>
            <pre className="mt-1 whitespace-pre-wrap rounded-lg border border-green-100 bg-green-50/80 p-3 text-xs text-green-950">
              {state.lastCommitSummary}
            </pre>
          </div>
        )}
        {state.committed && (
          <div className="rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-xs font-medium text-green-800">
            Equipment saved — redirecting to project management…
          </div>
        )}
      </div>
    </div>
  );
}
